import { ErrorMessage } from "formik";
import { Col,Row, Form } from "react-bootstrap";

const ViewTextInput = ({
    label,
    name,
    value,
    disabled = true,
    type,
    as,
    placeholder
  }) => (
    <Form.Group as={Col} className="form-group mb-2">
      <Form.Label htmlFor={name}  className="control-label align-self-center mb-0">
        {label}
      </Form.Label>
      <Col >
        <Form.Control
          type={type || "text"}
          name={name}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          as={as}
          style={as === "textarea" ? { resize: "none", height: "150px" } : {}}
        />
      </Col>
    </Form.Group>
  );

  export default ViewTextInput;